import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VDialog,
    {
      attrs: {
        "max-width": "400",
        "overlay-opacity": "0.67",
        "content-class": "lpu-medal-dialog-window",
        "data-qa": "lpu_medals_dialog",
      },
      model: {
        value: _setup.isOpened,
        callback: function ($$v) {
          _setup.isOpened = $$v
        },
        expression: "isOpened",
      },
    },
    [
      _setup.isOpened && _vm.items?.length
        ? _c(_setup.CoreSwiper, {
            staticClass: "lpu-medal-dialog",
            attrs: {
              "initial-slide": _vm.initialSlide,
              "slides-per-view": 1,
              "space-between": 16,
              "has-pagination": false,
              "has-navigation": !_setup.isMobile && _vm.items.length > 1,
              "equal-slides-height": "",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "slides",
                  fn: function ({ slideAttrs }) {
                    return _vm._l(_vm.items, function (item) {
                      return _c(
                        "div",
                        _vm._b({ key: item.id }, "div", slideAttrs, false),
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "lpu-medal-dialog__slide d-flex flex-column",
                            },
                            [
                              _c("img", {
                                staticClass: "lpu-medal-dialog__image",
                                attrs: { src: item.src, alt: item.alt },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "lpu-medal-dialog__header" },
                                [
                                  _c(
                                    VBtn,
                                    {
                                      staticClass: "lpu-medal-dialog__close",
                                      attrs: {
                                        icon: "",
                                        "data-qa": "lpu_medals_dialog_close",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _setup.isOpened = false
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        staticClass:
                                          "ui-icon-close-not-a-circle icon-secondary--text",
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "lpu-medal-dialog__body d-flex flex-column align-center",
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-body-1 text--text text-center mb-6",
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.alt) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "d-inline-flex align-center primary--text text-body-2 mt-auto text-decoration-none",
                                      attrs: {
                                        href: item.href,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        "data-qa": "lpu_medals_dialog_more",
                                      },
                                    },
                                    [
                                      _c("span", {
                                        staticClass:
                                          "ui-icon-circle-info ui-icon-fz-big mr-2",
                                      }),
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_setup.tStatic("Подробнее")) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    })
                  },
                },
              ],
              null,
              false,
              3862773093
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }